import { render, staticRenderFns } from "./useralljobtable.vue?vue&type=template&id=f2c22e28"
import script from "./useralljobtable.vue?vue&type=script&lang=js"
export * from "./useralljobtable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports